import { Divider, Skeleton, Space, Tabs, Tag } from 'antd';
import gql from 'graphql-tag';
import { useHistory, useParams } from 'react-router-dom';
import { useAuthedQuery } from 'utils/qlAuth';
import TabPane from 'antd/es/tabs/TabPane';
import { StoryMain } from './elements/StoryMain';
import { StoryMainMessageHistory } from './elements/StoryMessageHistory';
import { StoryFrames } from './elements/StoryFrames';
import { RunwaymlFramesAutomation } from './elements/RunwaymlFramesAutomation';
import { StorySeo } from './elements/StorySeo';
import { LeonardoFramesAutomation } from './elements/LeonardoFramesAutomation';
import { RunwaymlVideoAutomation } from './elements/RunwaymlVideoAutomation';
import { StoryBoard } from './elements/StoryBoard/StoryBoard';
import { TimelinePlan } from './elements/TimelinePlan/TimelinePlan';
import { ImportFramesFromOtherStories } from './elements/ImportFramesFromOtherStories';
import { StoryGPT } from './elements/StoryGPT';
import { TimelinePlanV2 } from './elements/TimelinePlan2/TimelinePlan2';

export interface OpenaiMessageInHistory {
  role: 'system' | 'assistant' | 'user' | 'function';
  content: string;
}

export const StoryPage = () => {
  const params = useParams<{ storyId: string; tabName: string }>();
  const tabName = params.tabName || 'main-form';
  const history = useHistory();

  const qStory = useAuthedQuery(
    gql`
      query StoryController_getStoryById($id: Int!) {
        StoryController_getStoryById(id: $id) {
          id
          title
          initMessage
          status
          ttsText
          fraimsCount
          messageHistory
          videoDescription
          videoTitle
          type
          promtTemplate
          promtTemplateIntro
          tags
          promtMutator
          extraVars
        }
      }
    `,
    {
      variables: { id: Number(params.storyId) },
    },
  );

  if (qStory.error) {
    return <div>error</div>;
  }
  const story = qStory.data?.StoryController_getStoryById || {};
  if (qStory.loading || !story) {
    return <Skeleton active />;
  }

  return (
    <>
      <h1>{story.title}</h1>
      <Tabs
        defaultActiveKey={tabName}
        onChange={(key: string) => {
          history.push(`/story/${params.storyId}/${key}`);
        }}
      >
        <TabPane tab="Project" key="main">
          <StoryMain qStory={qStory} storyId={Number(params.storyId)} />
        </TabPane>
        <TabPane tab="Chat history" key="messages">
          <StoryMainMessageHistory qStory={qStory} storyId={Number(params.storyId)} />
        </TabPane>
        <TabPane tab="Re-use frames" key="import">
          <ImportFramesFromOtherStories qStory={qStory} storyId={Number(params.storyId)} />
        </TabPane>
        <TabPane tab={'Frames'} key="frames">
          <StoryFrames qStory={qStory} storyId={Number(params.storyId)} />
        </TabPane>
        <TabPane tab={'StoryBoard'} key="storyboard">
          <StoryBoard qStory={qStory} storyId={Number(params.storyId)} />
        </TabPane>
        <TabPane tab={'Runway Images'} key="runway">
          <RunwaymlFramesAutomation qStory={qStory} storyId={Number(params.storyId)} />
        </TabPane>
        <TabPane tab={'Runway Video'} key="runway-video">
          <RunwaymlVideoAutomation qStory={qStory} storyId={Number(params.storyId)} />
        </TabPane>
        <TabPane tab={'Leonardo'} key="leonardo">
          <LeonardoFramesAutomation qStory={qStory} storyId={Number(params.storyId)} />
        </TabPane>
        <TabPane tab={'Timeline plan'} key="timeline-plan">
          <TimelinePlan qStory={qStory} storyId={Number(params.storyId)} />
        </TabPane>
        <TabPane tab={'Timeline plan v2'} key="timeline-plan2">
          <TimelinePlanV2 qStory={qStory} storyId={Number(params.storyId)} />
        </TabPane>
        <TabPane tab={'SEO'} key="seo">
          <StorySeo qStory={qStory} storyId={Number(params.storyId)} />
        </TabPane>
        <TabPane tab={'Ask GPT'} key="gpt">
          <StoryGPT qStory={qStory} storyId={Number(params.storyId)} />
        </TabPane>
      </Tabs>
    </>
  );
};
